



























































import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
    };
  },
  methods: {
    // ブラウザの自動補完を回避
    updateUsername(e: any) {
      this.loginForm.username = e.target.value;
    },
    updatePassword(e: any) {
      this.loginForm.password = e.target.value;
    },
    login() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const loginForm = this.loginForm;
          this.$emit("doLogin", loginForm);
        }
      });
    },
    forgetPassword() {
      this.$emit("forgetPassword");
    },
  },
});
